import React from "react";
import Select from "../../../form/Select";
import {optinFields} from "./QueryBuilder/QueryBuilder";
import {AbstractFilter, AbstractFilterProps} from "./AbstractFilter";

const queryFields = [...optinFields, {
    name: 'optin',
    label: 'OptIn',
    operators: [
        {
            name: '=',
            label: '='
        },
        {
            name: '!=',
            label: '!='
        },
    ],
    valueEditor: (props) => {
        return <div className="flex-grow-6">
            <Select
                component="OptIn"
                storeType="local"
                placeholder="OptIn"
                label={false}
                value={props.value}
                objectValue={false}
                disabled={props.disabled}
                saveChanges={(field, value) => {
                    props.handleOnChange(value);
                }}
            />
        </div>;
    }
}];

export default class OptInSubscriberFilter extends React.Component<AbstractFilterProps, any> {

    render() {
        return (
            <AbstractFilter {...this.props} component="OptInSubscriber" queryFields={queryFields} />
        );
    }
}